import React from "react";
import TradeContract from "./TradeContract";
import CommentForm from "./CommentForm";
import RepayContract from "./RepayContract";
import CloseContract from "./CloseContract";
import PrintContract from "./PrintContract";
import ProlongateContract from "./ProlongateContract";
import IncreaseContract from "./IncreaseContract";
import SwipeableViews from "react-swipeable-views";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PersonAddIcon from "@material-ui/icons/PersonAdd";

class ContractControls extends React.Component {
    state = {
        value: 0
    };

    switchTab = (e, value) => this.setState({ value });

    render() {
        const {
            car,
            client,
            manager,
            userPermissions,
            onAddComment,
            onDeleteComment,
            onContractIncrease,
            onContractRepay
        } = this.props;
        const { contract } = car;
        const {
            programDetails: { programType, sum, isBankrupt } = {}
        } = contract;
        const isLT = programType === "HOLD_LT";
        const isLeasing = programType === "PTS_LEASING";
        const { value } = this.state;

        const tabs = [
            { label: "Пролонгация", icon: <PersonAddIcon /> },
            { label: "Закрытие", icon: <PersonAddIcon /> },
            { label: "Комментарии", icon: <PersonAddIcon /> },
            { label: "Документы", icon: <PersonAddIcon /> },
            { label: "COM-TRADE", icon: <PersonAddIcon /> }
        ]
            .concat(
                isLT
                    ? []
                    : [{ label: "Уменьшить займ", icon: <PersonAddIcon /> }]
            )
            .concat(
                isLT || isLeasing
                    ? []
                    : [{ label: "Увеличить займ", icon: <PersonAddIcon /> }]
            );

        return (
            <React.Fragment>
                <Tabs value={value} onChange={this.switchTab} centered>
                    {tabs.map((tab, i) => (
                        <Tab key={i} label={tab.label} icon={tab.icon} />
                    ))}
                </Tabs>
                <SwipeableViews axis="x" index={value}>
                    <div dir="x">
                        {value === 0 && (
                            <ProlongateContract
                                contract={contract}
                                isJuridicalPerson={client.isJuridicalPerson}
                                isLT={isLT}
                            />
                        )}
                    </div>
                    <div dir="x">
                        {value === 1 && (
                            <CloseContract
                                contract={contract}
                                isJuridicalPerson={client.isJuridicalPerson}
                                isLT={isLT}
                            />
                        )}
                    </div>
                    <div dir="x">
                        {value === 2 && (
                            <CommentForm
                                car={car._id}
                                userPermissions={userPermissions}
                                comments={car.loan.phoneCalls}
                                onDeleteComment={onDeleteComment}
                                onAddComment={onAddComment}
                            />
                        )}
                    </div>
                    <div dir="x">
                        {value === 3 && (
                            <PrintContract
                                id={contract._id}
                                manager={manager}
                                sum={sum}
                                programType={programType}
                                isJur={client.isJuridicalPerson}
                            />
                        )}
                    </div>
                    <div dir="x">
                        {value === 4 && (
                            <TradeContract
                                carId={car._id}
                                contractId={contract}
                                isBankrupt={isBankrupt}
                            />
                        )}
                    </div>
                    <div dir="x">
                        {value === 5 && (
                            <RepayContract
                                contract={contract}
                                isJur={client.isJuridicalPerson}
                                onContractRepay={onContractRepay}
                            />
                        )}
                    </div>
                    <div dir="x">
                        {value === 6 && (
                            <IncreaseContract
                                contract={contract}
                                isJur={client.isJuridicalPerson}
                                onContractIncrease={onContractIncrease}
                            />
                        )}
                    </div>
                </SwipeableViews>
            </React.Fragment>
        );
    }
}

export default ContractControls;



// WEBPACK FOOTER //
// ./src/components/ContractControls.js